module.exports = __webpack_public_path__ + "img/sec3_3.b0c7d8f9.png";